import {Box, Paragraph, Text} from 'grommet'
import { useIntl } from 'react-intl'

import CenteredMain from '../../components/layout/CenteredMain'
import Page from '../../components/layout/Page'
import CollectedDataInfo from '../../components/infoButtons/CollectedDataInfo'
import AdditionalInformationForm from '../../components/forms/AdditionalInformation'

function AdditionalInformation() {
  const intl = useIntl()

  return (
    <Page titleTranslation="page.additionalInformation.title">
      <CenteredMain>
        <Box>
          <Paragraph textAlign="center" alignSelf="center">
            <Text size="large" weight="normal">
              {intl.formatMessage({id: 'moreInfo.text'})}
            </Text>
          </Paragraph>

          <AdditionalInformationForm />

          <Paragraph textAlign="center" alignSelf="center">
            <CollectedDataInfo />
          </Paragraph>
        </Box>
      </CenteredMain>
    </Page>
  )
}

export default AdditionalInformation
